document.addEventListener('DOMContentLoaded', function() {
let checkFiltersInterval = setInterval(() => {
    const filtersContainer = document.querySelector('.junip-filters-container');
    if (filtersContainer) {
        const filterButton = document.createElement('button');
        filterButton.className = 'junip-filter-button';
        filterButton.innerHTML = `<span>Filter</span><span class="junip-select-arrow">&nbsp;</span>`;
        filtersContainer.appendChild(filterButton);
        clearInterval(checkFiltersInterval);
        filterButton.addEventListener('click', function() {
            const filters = document.querySelector('.junip-filters-container');
            filters.classList.toggle('junip-filters-active');
        });
    }
}, 100);
});